import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge';

/**
 * tailwind-merge, настроенный под тему админки (src/app/styles/theme.css):
 * числовые радиусы (rounded-16), именованные тени и анимации из токенов.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: [validators.isInteger, 'pill'],
      shadow: ['modal', 'menu', 'dropdown', 'toast', 'segment-on', 'lang', 'focus-field'],
      animate: ['rise', 'rise-menu', 'skeleton'],
    },
  },
});

/** Склейка классов с разрешением конфликтов Tailwind (shadcn-утилита). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
